var $67f4d0b0de9f8a52$exports = {};
$67f4d0b0de9f8a52$exports = {
    "Clear search": `Suche zur\xfccksetzen`
};


export {$67f4d0b0de9f8a52$exports as default};
//# sourceMappingURL=de-DE.module.js.map
